import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_TITLE = 'SuiviFinance – Gestion de budget et finances personnelles';

const PATH_TITLES: Record<string, string> = {
  '/': 'Tableau de bord | ' + BASE_TITLE,
  '/login': 'Connexion | ' + BASE_TITLE,
  '/register': 'Inscription | ' + BASE_TITLE,
  '/onboarding': 'Bienvenue | ' + BASE_TITLE,
  '/forgot-password': 'Mot de passe oublié | ' + BASE_TITLE,
  '/transactions': 'Transactions | ' + BASE_TITLE,
  '/charts': 'Graphiques et rapports | ' + BASE_TITLE,
  '/annual-charts': 'Rapports annuels | ' + BASE_TITLE,
  '/solde-evolution': 'Évolution des soldes | ' + BASE_TITLE,
  '/periodic-transactions': 'Transactions périodiques | ' + BASE_TITLE,
  '/shared-expenses': 'Dépenses partagées | ' + BASE_TITLE,
  '/shared-expenses/add': 'Ajouter une dépense partagée | ' + BASE_TITLE,
  '/participants': 'Participants | ' + BASE_TITLE,
  '/accounts': 'Comptes | ' + BASE_TITLE,
  '/categories': 'Catégories | ' + BASE_TITLE,
  '/budgets': 'Budgets | ' + BASE_TITLE,
  '/loans': 'Prêts entre amis | ' + BASE_TITLE,
  '/analyse': 'Assistant financier | ' + BASE_TITLE,
  '/admin/users': 'Administration | ' + BASE_TITLE,
  '/admin/impersonate': 'Impersonation | ' + BASE_TITLE,
  '/settings': 'Paramètres | ' + BASE_TITLE,
  '/privacy': 'Confidentialité | ' + BASE_TITLE,
  '/terms': 'Conditions d\'utilisation | ' + BASE_TITLE,
};

/**
 * Met à jour document.title selon la route (SEO + onglet navigateur).
 */
const DocumentTitle: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname.replace(/\/$/, '') || '/';
    const title = PATH_TITLES[path] ?? BASE_TITLE;
    document.title = title;
  }, [pathname]);

  return null;
};

export default DocumentTitle;
